$(document).ready(function () {
  // PRODUCT PAGE IMAGES

  // ADD ACTIVE CLASS FOR THE THUMBNAIL
  var thumbnail = jQuery(".product-thumbnail").find("img");

  thumbnail.click(function () {
    thumbnail.removeClass("active");
    $(this).addClass("active");

    // UPDATE THE FEATURE IMAGE
    var src = $(this).attr("src");
    var dp = $(".product-featured-image img");
    dp.attr("src", src);
  });

  // ZOOM EFFECT ON HOVER
  // var tile = $(".product-featured-image")
  // .on('mouseover', function(){
  //     $(this).children('.tile').css("transform", "scale(2)")
  //     // $(this).css("transform", "scale(1.7)")
  // })
  // .on('mouseout', function(){
  //     $(this).children('.tile').css("transform", "scale(1)")
  //     // $(this).css("transform", "scale(1)")
  // })

  // .on('mousemove', function(e){
  //     $(this).children('.tile').css({'transform-origin': ((e.pageX - $(this).offset().left) / $(this).width()) * 100 + '% ' + ((e.pageY - $(this).offset().top) / $(this).height()) * 100 +'%'});
  //   })

  var $main = $(".product-featured-image"),
    $mainImg = $main.find(".tile"),
    $bool = false,
    $win = $(window),
    $widthImg = $mainImg.width(),
    $heightImg = $mainImg.height(),
    positionFunc = function (e) {
      return (
        (x = e.pageX - $main.offset().left), (y = e.pageY - $main.offset().top)
      );
    },
    zoomIn = function (e) {
      positionFunc(e);
      $mainImg
        .animate(
          {
            left: -x,
            top: -y,
            width: $widthImg * 2.01,
            height: $heightImg * 2.01,
          },
          200,
          function () {
            $main.bind("mousemove", function (e) {
              positionFunc(e);
              $mainImg.css({
                left: -x,
                top: -y,
              });
            });
          }
        )
        .css({
          cursor: "zoom-out",
        });
      $bool = true;
    },
    zoomOut = function () {
      $mainImg
        .animate(
          {
            left: 0,
            top: 0,
            width: $widthImg,
            height: $heightImg,
          },
          100
        )
        .css({
          cursor: "",
        });
      $main.unbind("mousemove");
      $bool = false;
    };

  $main
    .bind("mousedown", function (e) {
      if ($bool !== true) {
        zoomIn(e);
        $main.css({
          height: $heightImg,
        });
      } else {
        zoomOut();
        $main.css({
          height: $(this).height(),
        });
      }
    })
    .bind("mouseout", function () {
      zoomOut();
    });

  $win.scroll(function () {
    if ($bool) {
      zoomOut();
    }
  });

  window.onload = function () {
    new WOW().init();
  };

  // BUTTON CONTROLLER FOR PRODUCT PAGE
  $(".product-button").on("click", function () {
    var $button = $(this);
    var oldValue = $button.parent().find("input").val();

    if ($button.text() == "+") {
      var newVal = parseFloat(oldValue) + 1;
    } else {
      // Don't allow decrementing below zero
      if (oldValue > 0) {
        var newVal = parseFloat(oldValue) - 1;
      } else {
        newVal = 0;
      }
    }

    $button.parent().find("input").val(newVal);
  });

  // MOBILE MENU
  var click = 2;
  $("#menu-toggle").click(function () {
    $(this).toggleClass("open");
    click++;
    $("body").css("overflow", "hidden");
    $(".mobile-navigation").css({
      visibility: "visible",
      opacity: "1",
      transform: "translateX(0)",
      height: "100vh",
      position: "fixed",
      zIndex: 9999
    });
    $(".mobile-logo").css("visibility", "hidden");

    if (click % 2 == 0) {
      $(".mobile-navigation").css({
        visibility: "hidden",
        opacity: "0",
        transform: "translateX(-100%)",
        height: "0",
      });
      $(".mobile-logo").css("visibility", "visible");
      $("body").css("overflow", "auto");
    }
  });

  // ACCOUNT PREVIEW BUTTON
  $(".account-preview").on("click", function () {
    $(this)
      .find(".account-preview-body")
      .toggleClass("account-preview-body-reveal");
  });
  //END ACCOUNT PREVIEW

  // MOBILE SEARCH
  $(".magnifying").on("click", function () {
    $(".search-input-container").addClass("search-input-container-reveal");
  });

  $(".close").on("click", function () {
    $(this).parent().parent().removeClass("search-input-container-reveal");
  });

  $(".scrollbar-content").each(function () {
    if ($(this).height() > $(this).parent().height()) {
      $(this).parent().parent().addClass("column-scroll");
    }
  });

  //Remove local storage when collection link if from header
  let menuLinks = $(".menu").find("a");
  menuLinks.each(function () {
    $(this).click(function () {
      window.localStorage.removeItem("category");
      window.localStorage.removeItem("brand");
      window.localStorage.removeItem("priceRange");
      window.localStorage.removeItem("maxPrice");
      window.localStorage.removeItem("minPrice");
    });
  });

  let mobileMenuLinks = $(".mobile-menu").find("a");
  mobileMenuLinks.each(function () {
    $(this).click(function () {
      window.localStorage.removeItem("category");
      window.localStorage.removeItem("brand");
      window.localStorage.removeItem("priceRange");
      window.localStorage.removeItem("maxPrice");
      window.localStorage.removeItem("minPrice");
    });
  });

  // Reveal search bar
  $(".search-button").click(function (e) {
    if(!($(".search").hasClass("active"))) {
     $(".search").toggleClass("active");
      e.preventDefault();
    } 
  });
});

// ACCORDION
var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function () {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = "100%";
    }
  });
}
var nested = document.getElementsByClassName("nested-accordion");
var i = 0;
for (i = 0; i < nested.length; i++) {
  nested[i].addEventListener("click", function () {
    this.classList.toggle("active");
    var nestedPanel = this.nextElementSibling;
    if (nestedPanel.style.maxHeight) {
      nestedPanel.style.maxHeight = null;
    } else {
      nestedPanel.style.maxHeight = "100%";
    }
  });
}

// HOMEPAGE SLIDER
$("#slider-container-left, #slider-container-right, #mobileSlider").slick({
  dots: false,
  infinite: true,
  speed: 600,
  slidesToShow: 1,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 5000,
  fade: true,
  cssEase: "linear",
  pauseOnHover: false,
});

//SLIDER IN MENU
$(".shop-content-body").slick({
  slidesToShow: 6,
  infinite: false,
  prevArrow: $(".shop-prev"),
  nextArrow: $(".shop-next"),
  slidesToScroll: 3,
});


// update image on variant select
const selectVariantByClickingImage = {
  // Create variant images from productJson object
  _createVariantImage: function (product) {
    const variantImageObject = {};
    product.variants.forEach((variant) => {
      if (
        typeof variant.featured_image !== "undefined" &&
        variant.featured_image !== null
      ) {
        const variantImage = variant.featured_image.src
          .split("?")[0]
          .replace(/http(s)?:/, "");
        variantImageObject[variantImage] =
          variantImageObject[variantImage] || {};
        product.options.forEach((option, index) => {
          const optionValue = variant.options[index];
          const optionKey = `option-${index}`;
          if (
            typeof variantImageObject[variantImage][optionKey] === "undefined"
          ) {
            variantImageObject[variantImage][optionKey] = optionValue;
          } else {
            const oldValue = variantImageObject[variantImage][optionKey];
            if (oldValue !== null && oldValue !== optionValue) {
              variantImageObject[variantImage][optionKey] = null;
            }
          }
        });
      }
    });
    return variantImageObject;
  },
  _updateVariant: function (event, id, product, variantImages) {
    const arrImage = event.target.src
      .split("?")[0]
      .replace(/http(s)?:/, "")
      .split(".");
    const strExtention = arrImage.pop();
    const strRemaining = arrImage.pop().replace(/_[a-zA-Z0-9@]+$/, "");
    const strNewImage = `${arrImage.join(".")}.${strRemaining}.${strExtention}`;
    if (typeof variantImages[strNewImage] !== "undefined") {
      product.variants.forEach((option, index) => {
        const optionValue = variantImages[strNewImage][`option-${index}`];
        if (optionValue !== null && optionValue !== undefined) {
          const selects = document.querySelectorAll(
            "#" + id + " [class*=single-option-selector]"
          );
          const options = selects[index].options;
          for (let option, n = 0; (option = options[n]); n += 1) {
            if (option.value === optionValue) {
              selects[index].selectedIndex = n;
              selects[index].dispatchEvent(new Event("change"));
              break;
            }
          }
        }
      });
    }
  },
  _selectVariant: function () {
    const productJson = document.querySelectorAll("[id^=ProductJson-");
    if (productJson.length > 0) {
      productJson.forEach((product) => {
        const sectionId = product.id.replace(
          "ProductJson-",
          "shopify-section-"
        );
        const thumbnails = document.querySelectorAll(
          "#" + sectionId + ' img[src*="/products/"]'
        );
        if (thumbnails.length > 1) {
          const productObject = JSON.parse(product.innerHTML);
          const variantImages = this._createVariantImage(productObject);
          // need to check variants > 1
          if (productObject.variants.length > 1) {
            thumbnails.forEach((thumbnail) => {
              thumbnail.addEventListener("click", (e) =>
                this._updateVariant(e, sectionId, productObject, variantImages)
              );
            });
          }
        }
      });
    }
  },
};
if (document.readyState !== "loading") {
  selectVariantByClickingImage._selectVariant();
} else {
  document.addEventListener(
    "DOMContentLoaded",
    selectVariantByClickingImage._selectVariant()
  );
}